module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.controller,
      "fields": _vm.fields,
      "cancel": false,
      "ignoreEntityChanges": ""
    },
    on: {
      "submit": _vm.submit
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9db29542!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controller/ControllerTxPower.vue
// module id = 1180
// module chunks = 2